export default __webpack_public_path__ + "static/media/lnc_logo_appbar_large.da14d0f0.png";